<div editable-container [class.loading]="busy">
	@if (mailReplyOpen) {
		<task-action-mail [logEntryMail]="entry" (onSave)="sendMail($event)" (onCancel)="mailReplyOpen = false" />
	}
	<section>
		<icon [type]="getEntryIcon(entry)" class="{{ getColorCode(entry.statusType) }}" />
		<div>
			@if (entry.type == logEntryType.Internal) {
				<strong>{{ entry.userId | user: 'name' }}</strong>
				<span class="out-of-focus">
					{{ 'communication-log.internal-comment' | translate: { date: (entry.timestamp | customDate: 'fullDateTime') } }}
					@if (entry.edits.length > 0) {
						<br />
						<icon small type="clock-rotate-left" />
						{{ 'communication-log.edited' | translate }}
						{{ entry.modified | customDate: 'fullDateTime' }}
						{{ 'communication-log.edited-by' | translate }}
						{{ entry.userId | user: 'name' }}
					}
				</span>
				}
			@else {
				<strong>{{ 'communication-log.status.' + entry.statusType | translate }}</strong>
				<span class="out-of-focus">
					{{ entry.timestamp | customDate: 'fullDateTime' }}
					{{ entry.edits.length > 0 ? (entry.edits[0].userId ? '- ' + (entry.edits[0].userId | user: 'name') : '') : (entry.userId ? '- ' + (entry.userId | user: 'name') : '') }}
				</span>
				@if (entry.statusType == logEntryStatus.mailReceived && !mailReplyOpen) {
					<icon small (click)="mailReplyOpen = true" type="reply" />
				}
			}
		</div>

		@if (entry.type == logEntryType.Event && eventLogData) {
		<div>
			{{ 'communication-log.event.data-field' | translate }}: {{ 'communication-log.event.data-field.' + eventLogData.dataField | translate }}
			<div class="text-block" [formattedContent]="('communication-log.event.previous-value' | translate) + ': ' + getEventValue(eventLogData.dataType, eventLogData.previousValue)" [isHtmlContent]="isHtmlContent()"></div>
			<div class="text-block" [formattedContent]="('communication-log.event.current-value' | translate) + ': ' + getEventValue(eventLogData.dataType, eventLogData.currentValue)" [isHtmlContent]="isHtmlContent()"></div>
		</div>
		}
		@if (entry.type == logEntryType.Mail && emailData) {
			<div>
				<div><strong>{{ 'general.mail.send-date' | translate }}:</strong> {{ emailData.sendDateTime | customDate: 'fullDateTime' }}</div>
				<div><strong>{{ 'general.mail.sender' | translate }}:</strong> {{ emailData.sender }}</div>
				<div>
					<strong>{{ 'general.mail.recipients' | translate }}: </strong>
					@for (recipient of emailData.recipients; track recipient; let isLast = $last) { {{ recipient }}{{ isLast ? '' : '; ' }} }
				</div>
				<div><strong>{{ 'general.mail.subject' | translate }}:</strong> {{ emailData.subject }}</div>
				@if (emailData.attachments && emailData.attachments.length > 0) {
					<div>
						<strong>{{ 'general.mail.attachments' | translate }}: </strong>
						@for (attachment of emailData.attachments; track attachment.filePath; let isLast = $last) {
							<a (click)="downloadAttachment(attachment)">{{ attachment.attachmentName }}</a>{{ isLast ? '' : ', ' }}
						}
					</div>
				}
			</div>
		}
		@if (entry.type != logEntryType.Event) {
			<div>
				<editable-content *editableData="let edit from entry.comment" [editEnabled]="isEditable() && !busy" (valueChanged)="updateComment($event)">
					<display-content>
						@if (entry.comment != '') {
							<div class="text-block" [class.editable]="isEditable()" [formattedContent]="entry.comment" [isHtmlContent]="isHtmlContent()"></div>
						}
						@else {
							<div [class.editable]="isEditable()"><em>{{ 'general.no-comment' | translate }}</em></div>
						}
					</display-content>
					<edit-content>
						<custom-input [label]="'communication-log.comment-label' | translate"
									  [(value)]="edit.value"
									  [required]="true"
									  [inputType]="inputType.Textarea"></custom-input>
					</edit-content>
				</editable-content>
			</div>
		}
		@if (entry.notifications.length > 0) {
			<div class="out-of-focus">
				<strong>{{ 'general.notified' | translate }}: </strong>
				@for (notification of entry.notifications; track notification; let isLast = $last) {
					<span>{{ notification.assignedToUserId | user: 'name' }}{{isLast ? '' : ', '}}</span>
				}
			</div>
		}
	</section>
</div>
